import { pusherConfig } from './pusher.js';
import { currentUserStore } from './chats.store.js';
import { ChatModel } from './chat.model.js';
import { store } from './chats.store.js';

let channel;

function notifyAboutNewMessage(chat, lastMessageId) {
  const { isBlocked, isMuted, mentioned } = chat.storedChat;

  if (isBlocked) return;
  if (isMuted && !mentioned) return;

  const message = chat.message(lastMessageId);

  // This can happen if message was discarded because it didn't pass validation eg. (verify_patch.js)
  if (!message) return;

  const event = new CustomEvent('message-global-received', {
    detail: {
      message,
      chat,
    },
  });

  document.dispatchEvent(event);
}

function subscribeToUserChannel(user) {
  if (!user?.id) return;

  // Prevent multiple subscription to channel
  if (channel && channel.name.includes(`-${user.id}`)) return;

  // Unsubscribe from previous channel because user changed
  channel?.unsubscribe();

  const channelId =
    window.App?.config?.user?.channelId || `private-user-${user.id}`;

  channel = pusherConfig.pusher.subscribe(channelId);

  channel.bind('chat:message:created', async data => {
    let receivedForChat, lastMessageId;

    const promises = data.patches.map(async patch => {
      // Create message
      if (patch.path.length !== 4) return;

      const [_, chatId, _messages, messageId] = patch.path;

      lastMessageId = messageId;
      const chat = new ChatModel(chatId);
      receivedForChat = chat;

      if (chatId === store.value.activeChatId) return;

      if (!chat.storedChat) {
        await chat.load(json => {
          // We need to decrease unreadMessagesCount because other mechanism will take care of it
          // This will prevent unreadMessagesCount to be increased twice
          json.unreadMessagesCount -= 1;
          return json;
        });
      }

      return patch;
    });

    const patches = (await Promise.all(promises)).filter(Boolean);

    // Then apply patches
    ChatModel.applyPatches(patches);

    notifyAboutNewMessage(receivedForChat, lastMessageId);
  });
}

currentUserStore.subscribe(user => subscribeToUserChannel(user));
